<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
        <template slot="menuLeft">
            <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('online培训申请', '用户、工号、电话、部门、申请时间、回复')">导出Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
            <el-button icon="el-icon-edit" size="small" type="text" v-if="!scope.row.reply"
                       @click.stop="handleReply(scope.row,scope.index)">回复
            </el-button>
        </template>
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增通知', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText: '回复',
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '员工姓名',
              prop: 'user-username',
              editDisplay: false,
              span: 24,
              align: 'left',
            }, {
              label: '员工工号',
              prop: 'user_id',
              editDisplay: false,
              span: 24
            },
            {
              label: '手机号',
              editDisplay: false,
              prop: 'user-tel'
            },
            {
              label: '部门',
              prop: 'user-class',
              editDisplay: false,
              span: 24
            },
            {
              label: '状态',
              prop: 'user-status',
              editDisplay: false,
              span: 24,
              type: 'select',
              dicData: [{'label': '在职', 'value': 1}, {'label': '<span style="color: red">离职</span>', 'value': 2}]
            },
            {
              label: '申请时间',
              prop: 'created_at',
              editDisplay: false,
              span: 24
            }, {
              label: '回复',
              span: 24,
              overHidden: true,
              type: 'textarea',
              prop: 'reply'
            }, {
              label: '回复时间',
              span: 24,
              prop: 'reply_time',
              editDisplay: false
            }
          ]
        }
      }
    },
    methods: {
      // 回复
      handleReply(row, index) {
        this.$refs.crud.rowEdit(row, index)
      }
    }
  }
</script>
